import { NotificationActionEnum } from "../Notification/INotification";

export interface IPreferences {
  Action: NotificationActionEnum;
  Preference: FileNotificationPreferenceEnum | 
  TopicNotificationPreferenceEnum | 
  PlottingNotificationPreferenceEnum | 
  DisciplineNotificationPreferenceEnum;
}

export interface IPreferencesResponse {
  FilePreferences: IPreferences[];
  TopicPreferences: IPreferences[];
  PlottingPreferences: IPreferences[];
  GlobalPreferences: IPreferences[];
}

export interface IPreferencesEmailResponse {
  FileEmailPreferences: IPreferences[];
  TopicEmailPreferences: IPreferences[];
  PlottingEmailPreferences: IPreferences[];
}

export interface IPreferencesRequest {
  action: number;
  preference: number;
}

export enum FileNotificationPreferenceEnum {
  None = 0,
  AllFolders = 1,
  FollowedFolders = 2,
  FollowedDisciplines = 3
}

export enum TopicNotificationPreferenceEnum {
  None = 0,
  All = 1,
  Followed = 2
}

export enum PlottingNotificationPreferenceEnum {
  None = 0,
  All = 1,
  CreatedByMe = 2
}

export enum DisciplineNotificationPreferenceEnum {
  None = 0,
  All = 1,
  Followed = 2
}
